import * as React from "react";
import { forwardRef } from "react";
const SvgIconAttachedFile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 3v16h13.308V7.058l-.173-.192-3.693-3.693L14.25 3zm1.231 1.231h7.154v3.692h3.692v9.846H6.231zm8.385.885 1.577 1.577h-1.578zM8.077 9.154v1.231h7.154V9.154zm0 2.462v1.231h7.154v-1.232zm0 2.462v1.231h7.154v-1.232z", "data-name": "icon/file", transform: "translate(-3.65 -3)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconAttachedFile);
export { ForwardRef as ReactComponent };
